<script setup>
</script>

<template>
  <Teleport to="body">
    <div
      class="blockscreen"
      aria-busy="true"
      aria-live="polite"
    >
      <span class="spinner-border spinner-border-xl text-primary" />
    </div>
  </Teleport>
</template>
